import orderManager from '../../manager/order';
import util from '../../utils/util';
import Block from '../Base/Block';
import Image from '../Base/Image';
import Text from '../Base/Text';
import View from '../Base/View';
import Price from '../Price';
import './index.scss'

const Productinfoinorder = (props: {
  productInfo: any,
  orderInfo?: any,
  fromPage?: string,
  showBottomBorder: boolean,
  showShipmengBtn?: boolean,
  clickToProductDetail?: boolean,
  onRequestOpenShipmentDialog?: (productInfo: any) => void
}) => {

  const { productInfo, orderInfo, fromPage, showBottomBorder } = props;
  if (!productInfo) {
    return null;
  }
  return <Block>
    <View className="product-info flex-conainer" onClick={(e) => {
      if (props.clickToProductDetail) {
        e.stopPropagation();
        util.navigateTo("/detail?isrmmp=1&hidemenu=1&internal=1&id=" + productInfo.ProductId);
      }
    }}>
      <Image
        className="product-thumb flex-fix"
        src={productInfo.PictureUrl}
      ></Image>
      <View className="product-meta">
        <Text className="product-name">
          {productInfo.ProductName || productInfo.Name}
        </Text>
        <Text className="product-type">{productInfo.AttributeInfo}</Text>
        <View className="product-price">
          <View className="product-price-value">
            <Price
              value={productInfo.UnitPriceStr || productInfo.UnitPrice}
              size={32}
            ></Price>
          </View>
          <View className="product-count">
            {'×' + productInfo.Quantity}
          </View>
          {/*  已发货、已完成订单可查看物流或码券信息  */}
          {(orderInfo && (orderInfo.OrderStatusId === 20 ||
            orderInfo.OrderStatusId === 30 ||
            orderInfo.OrderStatusId === 40)) && (
              <Block>
                {productInfo.IsDownload && (
                  <View
                    className="viewCouponCode"
                    onClick={(e) => {
                      e.stopPropagation()
                      orderManager.viewExchangeCode(productInfo.Id)
                    }}
                  >
                    查看券码
                  </View>
                )}
                {orderInfo.OrderStatusId != 20 &&
                  !productInfo.IsDownload &&
                  props.showShipmengBtn && (
                    <View
                      className="viewCouponCode"
                      onClick={(e) => {
                        e.stopPropagation()
                        if (props.onRequestOpenShipmentDialog) {
                          props.onRequestOpenShipmentDialog(productInfo)
                        }
                      }}
                    >
                      查看物流
                    </View>
                  )}
              </Block>
            )}
        </View>
      </View>
    </View>
    {/*  不可结算提示 && productInfo.NotReturnable */}
    {fromPage == 'checkout' && productInfo.NotReturnable && (
      <View className="returnable-tips-container-c">
        <View className="returnable-tips">
          <Image
            className="returnable-tips-icon"
            src={require('../../images/cart-warning.png')}
          ></Image>
          <Text>该商品不支持退换货</Text>
        </View>
        {productInfo.Warnings.map((item: any) => {
          return (
            <View className="returnable-tips">
              <Image
                className="returnable-tips-icon"
                src={require('../../images/cart-warning.png')}
              ></Image>
              <Text>{item}</Text>
            </View>
          )
        })}
      </View>
    )}
    {/*  底边线  */}
    {showBottomBorder && (
      <View className="product-info-border">
        <View className="product-info-border-inner"></View>
      </View>
    )}
  </Block>
}

export default Productinfoinorder;